import React, { useState } from 'react';
import { VideoModal } from '@/components/VideoModal';

interface Activity {
  id: string;
  title: string;
  description?: string;
  category: string;
  duration: number;
  embed_url?: string;
}

interface VideoModalManagerProps {
  children: (handleWatchVideo: (activity: Activity) => void) => React.ReactNode;
}

export const VideoModalManager: React.FC<VideoModalManagerProps> = ({
  children,
}) => {
  const [selectedActivity, setSelectedActivity] = useState<Activity | null>(null);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const handleWatchVideo = (activity: Activity) => {
    setSelectedActivity(activity);
    setIsVideoModalOpen(true);
  };

  const handleCloseVideoModal = () => {
    setIsVideoModalOpen(false);
    setSelectedActivity(null);
  };

  return (
    <>
      {children(handleWatchVideo)}
      
      {selectedActivity && (
        <VideoModal
          isOpen={isVideoModalOpen}
          onClose={handleCloseVideoModal}
          activity={selectedActivity}
        />
      )}
    </>
  );
};